import {Component, OnDestroy, OnInit, ViewChild, TemplateRef, Inject, Optional} from '@angular/core';
import {Message} from 'primeng/components/common/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {TranslateService} from '@ngx-translate/core';
import {ModalCloseComponent, ServiceConfService} from '../shared/index';
import {StateService} from '../shared/services/state.service';
import {catchError, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';
import {SelectItem, TreeNode} from 'primeng/api';
import {ConfirmationService} from 'primeng/api';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar} from '@angular/material';
import {RemoveDriverDialogComponent} from '@app/cab/drivers/remove-driver-dialog/remove-driver-dialog.component';
import {DriverService} from '@app/shared/services/driver.service';
import {OrderFormDriverDriverUnassignComponent} from '@app/dashboard/order-form-driver-driver-unassign/order-form-driver-driver-unassign.component';
import {OrderService} from '@app/shared/services/order.service';
import {NotificationService} from '@app/shared/services/notification.service';
import {CurrencyValidation} from '@app/shared/controls/currency-validation';

@Component({
    selector: 'app-service-conf-edit',
    templateUrl: './service-conf-edit.component.html',
    styleUrls: ['./service-conf-edit.component.scss']
})
export class ServiceConfEditComponent implements OnInit, OnDestroy {

    @ViewChild('controlMenu') controlMenu: TemplateRef<any>;
    configs: TreeNode[] = [];
    title = 'config';
    settingsToChange = new Map();
    msgs: Message[] = [];
    service_id: string;
    service_city_name: string;
    service: any;
    services;
    messages: string;
    translate: any;
    searchString = '';
    canSearch = false;
    canClear = false;
    componentDestroyed = new Subject();
    expandTree = false;
    opened = false;

    reasonFormGroup: FormGroup;
    reasons: FormArray;

    constructor(translate: TranslateService,
                private taxiServiceSettingsService: ServiceConfService,
                private messageService: MessageService,
                private stateService: StateService,
                private confirmationService: ConfirmationService,
                private orderService: OrderService,
                private notification: NotificationService,
                private dialog: MatDialog,
                @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
                public dialogRef: MatDialogRef<ServiceConfEditComponent>,
                private formBuilder: FormBuilder) {
        this.translate = translate;
    }


    ngOnInit() {
        this.stateService.getParameter('services').pipe(
            takeUntil(this.componentDestroyed),
        ).subscribe(data => {
            this.services = data;
            this.service = this.services[0];
            this.service_id = this.services[0].id;
            this.service_city_name = this.services[0].city.name;

            this.taxiServiceSettingsService.getTaxiserviceSettings(this.service_id, this.searchString)
                .subscribe(
                    configs => {
                        this.configs = configs;
                        this.getReasons();
                    }
                );
        });

        this.exapandORcollapse();
    }

    get formData() {
        return <FormArray>this.reasonFormGroup.get('reasons');
    }

    toFormGroup(reason) {
       /* let isNum = (num: AbstractControl) =>
            isNaN(Number(num.value)) ? {'is_nan': true} : null;*/
        return this.formBuilder.group({
            display_name: [reason.display_name, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]],
            penalty_value: [reason.penalty_value, [Validators.required, CurrencyValidation.CurrencyString]],
            //penalty_trip_cancel_type: [reason.penalty_trip_cancel_type, [Validators.required]],
            id: [reason.id]
        });
    }

    exapandORcollapse() {
        for (let node of this.configs) {
            if (node.children) {
                if (this.expandTree) {
                    node.expanded = true;
                } else {
                    node.expanded = false;
                }
            }
        }
    }

    checkLength(event) {
        if (this.searchString.length > 2) {
            this.canSearch = true;
            this.canClear = true;

            if (event.which === 13) {
                event.preventDefault();
                this.search();
            }
        }
    }

    search() {
        this.taxiServiceSettingsService.getTaxiserviceSettings(this.service_id, this.searchString)
            .subscribe(
                configs => {
                    this.configs = configs;
                    if (this.configs.length != 0) {
                        this.expandTree = true;
                        this.exapandORcollapse();
                    }
                }
            );
    }

    clear() {
        this.searchString = '';
        this.canSearch = false;
        this.canClear = false;
        this.taxiServiceSettingsService.getTaxiserviceSettings(this.service_id, this.searchString)
            .subscribe(
                configs => {
                    this.configs = configs;
                }
            );
    }

    reloadServiceSettings() {
        this.settingsToChange = new Map();
        this.service_id = this.service.id;
        this.service_city_name = this.service.city.name;
        this.getConfiguration();

        this.getReasons();
    }

    ngOnDestroy() {
        this.componentDestroyed.next(true);
        this.componentDestroyed.unsubscribe();
    }

    showViaService(result, title, text) {
        this.messageService.add({severity: result, summary: title, detail: text});
    }

    onCheckbox(event, key) {
        let boolAsInt = (event == true ? '1' : '0');
        this.updateConfiguration(key, boolAsInt);
    }

    validate(key, value, rules) {
        const validationRules = rules.split('|');
        this.messages = '';
        if (validationRules.includes('required') && value.length == 0) {
            this.messages = this.translate.get(key).value + ': ' + this.translate.get('VALUE_REQUIRED').value;
        } else if (validationRules.includes('integer') && Number.isInteger(value)) {
            this.messages = this.translate.get(key).value + ': ' + this.translate.get('SETTINGS_VALUE_MUST_BE').value + ' integer. ';
        } else if (validationRules.includes('numeric') && isNaN(parseFloat(value))) {
            this.messages = this.translate.get(key).value + ': ' + this.translate.get('SETTINGS_VALUE_MUST_BE').value + ' numeric. ';
        } else if (validationRules.includes('string') && typeof(value) != 'string') {
            this.messages = this.translate.get(key).value + ': ' + this.translate.get('SETTINGS_VALUE_MUST_BE').value + ' string. ';
        }

        if (validationRules.findIndex(maxvalue => /^max:/.test(maxvalue)) > -1) {
            let onPosition = validationRules.findIndex(maxvalue => /^max:/.test(maxvalue));
            let maxRule = validationRules[onPosition].split(':')[1];
            if (parseFloat(value) > parseFloat(maxRule)) {
                this.messages = this.messages + ' ' + this.translate.get(key).value + ': ' + this.translate.get('SETTINGS_VALUE_MUST_BE_LESS_OR_EQUAL').value + maxRule + '.';
            }
        }

        if (validationRules.findIndex(minvalue => /^min:/.test(minvalue)) > -1) {
            let onPosition = validationRules.findIndex(minvalue => /^min:/.test(minvalue));
            let minRule = validationRules[onPosition].split(':')[1];
            if (parseFloat(value) < parseFloat(minRule)) {
                this.messages = this.messages + ' ' + this.translate.get(key).value + ': ' + this.translate.get('SETTINGS_VALUE_MUST_BE_MORE_OR_EQUAL').value + ' ' + minRule + '.';
            }
        }

        if (validationRules.findIndex(minvalue => /^in:/.test(minvalue)) > -1) {
            let onPosition = validationRules.findIndex(minvalue => /^in:/.test(minvalue));
            let enumInStr = validationRules[onPosition].split(':')[1];
            let enumIn = enumInStr.split(',');
            if (enumIn.indexOf(value) < 0) {
                this.messages = this.messages + ' ' + this.translate.get(key).value + ': ' + this.translate.get('SETTINGS_VALUE_MUST_BE_IN_DIAPASON').value + ' "' + enumInStr + '".';
            }
        }

        if (this.messages.length == 0) {
            this.updateConfiguration(key, value);
        } else {
            this.showViaService(
                'error',
                'Error Message',
                this.messages);
        }
    }

    saveAll() {
        this.settingsToChange.forEach((value, key) => {
            this.updateConfigurationOnServer(key, value);
        });
        this.settingsToChange = new Map();
    }

    onResetAll() {
        this.ngOnInit();
    }

    updateConfiguration(key, config_value) {
        this.settingsToChange.set(key, config_value);
    }

    updateConfigurationOnServer(key, config_value) {
        this.taxiServiceSettingsService.updateTaxiserviceSettings(this.service_id, key, config_value)
            .subscribe(
                res => {
                    if (res) {
                        this.showViaService(
                            'success',
                            'Updated',
                            this.translate.get(key).value + ': ' + this.translate.get('NEW_VALUE_FOR_CONFIGURATION_SETTING').value + ' ' + config_value);
                    }
                }
            );
    }

    getConfiguration() {
        this.taxiServiceSettingsService.getTaxiserviceSettings(this.service_id, this.searchString)
            .subscribe(
                configs => {
                    this.configs = configs;
                    this.exapandORcollapse();
                }
            );
    }


    getReasons() {
        this.reasonFormGroup = this.formBuilder.group({
            reasons: this.formBuilder.array([]),
        });

        this.taxiServiceSettingsService.getReasons(this.service_id).subscribe({
            next: obj => {
                this.reasons = this.reasonFormGroup.get('reasons') as FormArray;
                obj['data'].map(reason => {
                    if(reason.penalty_value == null){
                        reason.penalty_value = '0';
                    }
                    this.reasons.push(this.toFormGroup(reason));
                });
            },
            error: err => {
                this.notification.handleServiceError('', err.error);
            }
        });
    }

    updateReason(reason) {
        if (reason.id == '') {
            this.taxiServiceSettingsService.storeReason(reason, this.service_id).subscribe({
                next: obj => {
                    if (obj) {
                        this.showViaService(
                            'success',
                            'Created',
                            this.translate.get('TRIP_CANCEL_PENALTY_CREATED').value);
                    }
                    this.getReasons();
                },
                error: err => {
                    this.notification.handleServiceError('', err.error);
                }
            });
        } else {
            this.taxiServiceSettingsService.updateReason(reason, this.service_id).subscribe({
                next: obj => {
                    this.showViaService(
                        'success',
                        'Updated',
                        this.translate.get('TRIP_CANCEL_PENALTY_UPDATED').value);
                    this.getReasons();
                },
                error: err => {
                    this.notification.handleServiceError('', err.error);
                }
            });
        }
    }

    removeReason(id) {
        if (id == '') {
            this.getReasons();
            return;
        }
        let dialogRef = this.dialog.open(ModalCloseComponent, <MatDialogConfig>{
            data: { 'headerTemplate': 'delete_penalty' }
        });
        this.opened = true;
        dialogRef.afterClosed().subscribe(res => {
            if (res == 'true') {
                this.taxiServiceSettingsService.removeReason(id, this.service_id).subscribe({
                    next: obj => {
                        if (obj) {
                            this.showViaService(
                                'success',
                                'Deleted',
                                this.translate.get('TRIP_CANCEL_PENALTY_DELETED').value);
                        }
                        this.getReasons();
                    },
                    error: err => {
                        this.notification.handleServiceError('', err.error);
                    }
                });
            }
        });
    }

    createReason() {
        this.reasons.push(this.toFormGroup({
            display_name: '',
            penalty_value: '+0',
            id: ''
        }));
        return 1;
    }

    cancel() {
        this.getReasons();
    }
}



// WEBPACK FOOTER //
// ./src/app/service-conf-edit/service-conf-edit.component.ts